import { createAction, props } from '@ngrx/store';

import {
  AuthResetParams,
  AuthTokenResponse,
  BusinessAccount,
  EnabledSolutionPermissions,
  LinkedBusinessAccount,
  User,
} from '@shared/models';

export namespace AuthActions {
  export const loginSuccess = createAction(
    '[Auth/API] Login Success',
    props<{ user: User; businessAccount: LinkedBusinessAccount | null; tenant: string | null }>(),
  );

  export const selectBusinessAccount = createAction(
    '[Auth/API] Select Business Account',
    props<{ businessAccount: LinkedBusinessAccount | null }>(),
  );

  export const showSplashScreen = createAction('[Auth] Show Splash Screen');

  export const loginFailure = createAction('[Auth/API] Login Failure', props<{ error: string }>());

  export const businessAccountDetails = createAction(
    '[Auth/API] Business Account Details',
    props<{ businessAccountDetails: BusinessAccount | null }>(),
  );

  export const businessAccountSwitchComplete = createAction('[Auth] Business Account Switch Complete');

  export const logout = createAction('[Auth] Logout', props<{ params?: AuthResetParams }>());

  export const logoutCompleted = createAction('[Auth] Logout Completed', props<{ params?: AuthResetParams }>());

  export const refreshToken = createAction('[Auth] Refresh Token');

  export const refreshTokenSuccess = createAction('[Auth] Refresh Token Success', props<{ tokenInfo: AuthTokenResponse }>());

  export const setSponsorAuthTenant = createAction('[Sponsor Auth Tenant] Set', props<{ isSponsorTenant: boolean }>());

  export const noActiveSession = createAction('[Auth] No Active Session');

  export const rehydrateState = createAction('[Auth] Rehydrate State');

  export const rehydrateBusinessAccountDetails = createAction(
    '[Auth/API] Rehydrate Business Account Details',
    props<{ businessAccountDetails: BusinessAccount | null }>(),
  );

  export const loadEnabledSolutions = createAction('[Auth] Load Enabled Solutions');

  export const loadEnabledSolutionsSuccess = createAction(
    '[Auth/API] Load Enabled Solutions Success',
    props<{ enabledSolutions: EnabledSolutionPermissions }>(),
  );

  export const loadEnabledSolutionsFailure = createAction('[Auth/API] Load Enabled Solutions Failure', props<{ error: string }>());
  export const linkedBusinessAccountsListLoad = createAction('Linked Business Account List Load');
  export const linkedBusinessAccountsListSuccess = createAction(
    'Linked Business Account List Success',
    props<{ linkedBusinessAccounts: LinkedBusinessAccount[] }>(),
  );
  export const linkedBusinessAccountsListFailure = createAction('Linked Business Account List Failure', props<{ error: string }>());
}
